import React from "react";
import { motion } from "framer-motion";

export default function Guide() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      style={{
        padding: "2rem",
        maxWidth: "900px",
        margin: "0 auto",
        textAlign: "left",
      }}
    >
      <motion.h1
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
        style={{
          fontSize: "2.2rem",
          color: "#0079C0",
          marginBottom: "1rem",
          textAlign: "center",
        }}
      >
        How to Use SeizureBiomeDB
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        style={{
          color: "#555",
          fontSize: "1.1rem",
          marginBottom: "2.5rem",
          textAlign: "center",
          maxWidth: "700px",
          margin: "0 auto 2.5rem auto",
        }}
      >
        This portal enables exploration of research connecting the gut microbiome to epilepsy across populations. Follow this guide to navigate and get the most out of the platform.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "1.5rem",
        }}
      >
        {[
          {
            heading: "Browse Study Categories",
            description:
              "Start from the homepage where you’ll find cards for Pediatric Epilepsy, Adult Epilepsy, and Preclinical Models. Clicking one opens related studies with details and filters.",
          },
          {
            heading: "Explore Global Study Distribution",
            description:
              "View the heatmap at the bottom of the homepage to see the global density of studies. This helps identify which countries are most active in epilepsy-microbiome research.",
          },
          {
            heading: "Search for Specific Studies",
            description:
              "Navigate to the Search page from the top menu to find studies by keywords, subjects, or tags. The results page provides structured summaries and links to full details.",
          },
          {
            heading: "Use Resources and Learn More",
            description:
              "Explore the Resources and About sections to understand the context behind the portal — including glossary terms, data origins, and how this research helps epilepsy care.",
          },
          {
            heading: "Get Involved and Contribute",
            description:
              "If you have relevant studies or data, consider contributing to the portal. Check the 'Contribute' section for guidelines on how to submit your research.",
          },
        ].map((section, i) => (
          <div
            key={i}
            style={{
              backgroundColor: "#f8fafc",
              padding: "1.8rem",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
            }}
          >
            <h2
              style={{
                color: "#0079C0",
                marginBottom: "0.8rem",
                fontSize: "1.4rem",
                borderBottom: "2px solid #e5e7eb",
                paddingBottom: "0.3rem",
              }}
            >
              {section.heading}
            </h2>
            <p style={{ color: "#444", fontSize: "1rem", lineHeight: "1.6" }}>
              {section.description}
            </p>
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
}